import React, { useEffect, useState } from 'react';
import Header from '../../components/dashboard/Header';
import Sidebar from '../../components/dashboard/Sidebar';
import AdminStates from './DashboardStates';
import User from './User';
import Request from './Request';
import Company from './Company';
import { getMineAccount } from '../../redux/action/auth';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import ActivityPoints from './Activity'
const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState('Dashboard');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mineData } = useSelector((state) => state.auth);

  // Fetch user account details on mount
  useEffect(() => {
    dispatch(getMineAccount());
  }, [dispatch]);

  // Navigate based on user type
  useEffect(() => {
    if (mineData) {
      console.log("mineData for navigation:", mineData);
      if (mineData?.userType === 'ProLeadPartner') {
        navigate('/'); // Use navigate instead of window.location.href
      } else if (mineData?.userType === 'Admin') {
        // No navigation required because this is the admin dashboard
        console.log("Admin user, staying on admin dashboard.");
      }
    }
  }, [mineData, navigate]); // Include navigate in the dependency array

  // Loading indicator
  if (!mineData) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <Circles height="80" width="80" color="#4fa94d" ariaLabel="loading" />
      </div>
    );
  }

  const renderSection = () => {
    switch (activeSection) {
      case 'Dashboard':
        return <AdminStates />;
      case 'Users':
        return <User />;
      case 'Request':
        return <Request />;
      case 'Company':
        return <Company />;
        case 'ActivityPoints':
          return <ActivityPoints />;
      default:
        return <AdminStates />;
    }
  };

  return (
    <div className='flex h-screen bg-gray-100'>
      {/* Sidebar */}
      <Sidebar
        setActiveSection={setActiveSection}
        activeSection={activeSection}
      />

      {/* Main Content Area */}
      <div className='flex-1 flex flex-col'>
        {/* Header */}
        <Header />

        {/* Scrollable Content */}
        <div className='flex-1 overflow-y-scroll p-6'>{renderSection()}</div>
      </div>
    </div>
  );
};

export default AdminDashboard;
